import { render, staticRenderFns } from "./ArcadeWon.vue?vue&type=template&id=2b57ce40&scoped=true&"
import script from "./ArcadeWon.vue?vue&type=script&lang=js&"
export * from "./ArcadeWon.vue?vue&type=script&lang=js&"
import style0 from "./ArcadeWon.vue?vue&type=style&index=0&id=2b57ce40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57ce40",
  null
  
)

export default component.exports